import Vue from 'vue'
import App from './App.vue'
import '@/assets/css/tailwind.scss'
import "@/assets/css/main.scss"
import Toasted from 'vue-toasted';
import Meta from 'vue-meta';
import VueAnalytics from 'vue-analytics';


Vue.config.productionTip = false

Vue.use(Toasted, {
  position: 'bottom-center',
  duration: 2000,
  iconPack : 'material'
})

Vue.use(Meta);

// https://medium.com/js-dojo/how-to-use-google-analytics-in-your-vue-app-with-vue-analytics-9cdb913301d1
Vue.use(VueAnalytics, {
  id: 'UA-77080723-1',
  // router
})

new Vue({
  render: h => h(App)
}).$mount('#app')
